import React from 'react';
import DashboardLayout from '../../components/layout/DashboardLayout';
import { FaEdit, FaClipboardCheck, FaCalendarAlt } from 'react-icons/fa';

const Exams = () => {
  const upcomingExams = [
    { id: 'EX-2026-APR-01', title: 'Science Monthly Assessment - April', date: '2026-04-28', time: '02:00 PM', duration: '2 Hours' },
    { id: 'EX-2026-MAY-01', title: 'Biology Term Test', date: '2026-05-15', time: '09:00 AM', duration: '3 Hours' },
  ];

  return (
    <DashboardLayout title="Exams">
      <div className="space-y-8">
        
        {/* Exam Header */}
        <div className="flex items-center justify-between">
           <h2 className="text-2xl font-bold text-slate-700">Upcoming Exams</h2>
           <div className="flex items-center gap-2 px-4 py-2 bg-blue-50 text-blue-600 rounded-lg font-bold text-xs">
              <FaClipboardCheck />
              Results Available: 0
           </div>
        </div>

        {/* Exams Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
           {upcomingExams.map((exam, idx) => (
             <div key={idx} className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm hover:shadow-md transition-all group border-l-4 border-l-blue-500">
                <div className="flex justify-between items-start mb-4">
                   <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">{exam.id}</span>
                   <FaEdit className="text-blue-500 opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
                <h3 className="text-lg font-bold text-slate-700 mb-6">{exam.title}</h3>
                
                <div className="space-y-3">
                   <div className="flex items-center gap-3 text-sm text-slate-500">
                      <FaCalendarAlt className="text-slate-300" />
                      <span>{exam.date} at {exam.time}</span>
                   </div>
                   <div className="flex items-center gap-3 text-sm text-slate-500">
                      <div className="w-4 h-4 rounded-full bg-slate-100 flex items-center justify-center text-[8px] font-bold">T</div>
                      <span>Duration: {exam.duration}</span>
                   </div>
                </div>

                <button className="w-full mt-8 py-3 bg-slate-50 hover:bg-blue-600 hover:text-white text-slate-600 font-bold rounded-lg transition-all text-sm">
                   View Details
                </button>
             </div>
           ))}
        </div>

        {/* Placeholder for Empty States */}
        {upcomingExams.length === 0 && (
          <div className="py-20 flex flex-col items-center justify-center text-center space-y-4 bg-slate-50 rounded-2xl border-2 border-dashed border-slate-200">
             <FaEdit className="text-slate-200 text-6xl" />
             <p className="text-slate-400 font-medium">No upcoming exams scheduled at the moment.</p>
          </div>
        )}

      </div>
    </DashboardLayout>
  );
};

export default Exams;
